<!-- HxThreeColumnLayout Template

Component provides three-column flexbox layout with configurable gap spacing.
Uses content projection with directive selectors for left/center/right columns.

Each column takes up 33.33% width on desktop, stacks to 100% on mobile (≤768px).
Columns flex vertically and apply the same gap between items as between columns.
Columns are top-aligned, allowing different heights.
Empty columns preserve their space for layout consistency.

ARIA labels are optional - applied via directive inputs (not component inputs).
-->

<div class="hx-three-column-layout-left">
  <ng-content select="[hxThreeColumnLeft]"></ng-content>
</div>

@if (showSeparator()) {
  <hx-divider [vertical]="true" class="hx-three-column-vertical-divider"></hx-divider>
}

<div class="hx-three-column-layout-center">
  <ng-content select="[hxThreeColumnCenter]"></ng-content>
</div>

@if (showSeparator()) {
  <hx-divider [vertical]="true" class="hx-three-column-vertical-divider"></hx-divider>
}

<div class="hx-three-column-layout-right">
  <ng-content select="[hxThreeColumnRight]"></ng-content>
</div>
